import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { ActualizarColeccionModel } from '../models/actualizar-coleccion.model';

@Injectable({providedIn: 'root'})
export class AcutalizarColeccionService {
    
    constructor(private apiService: ApiService) { }
        
    actualizacionColeccion(body:ActualizarColeccionModel){
        const url= `/bien_cultural/cambio_coleccion` 
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, {}, 'Error al actualizar coleccion.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }
}